import { RichText } from 'prismic-reactjs';
import { IArticleMetaProps } from './interfaces';
import Image from 'next/image';
import { Routes } from '../../../models/enums/routes';
import { imageSerializer } from '../../../utils/imageSerializer';
import { MetaDate, MetaName, MetaTagLink } from './styles';

const ArticleMeta = (props: IArticleMetaProps) => {
  const formattedPublishDate = new Date(props.publishDate).toLocaleDateString(
    'en-US',
    {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }
  );

  return (
    <div className={`${props.className}-meta`}>
      {props.authorImage && (
        <div className={`${props.className}-meta__image`}>
          <Image
            {...imageSerializer(props.authorImage)}
            className={'person__image'}
          />
        </div>
      )}
      <div className={`${props.className}-meta__info`}>
        {props.author && RichText.asText(props.author) !== '' && (
          <MetaName>{RichText.asText(props.author)}</MetaName>
        )}
        <div className={`${props.className}-meta__details`}>
          <MetaDate>{formattedPublishDate}</MetaDate>
          <div className="divider">|</div>
          <>
            {props.tags.map((tag) => (
              <MetaTagLink
                key={tag}
                href={`${Routes.InsightsTag}${tag}`}
                aria-label={tag}
                className={`${props.className}-meta__tag`}
              >
                {tag}
              </MetaTagLink>
            ))}
          </>
        </div>
      </div>
    </div>
  );
};

export default ArticleMeta;
